import React, { PureComponent} from 'react';
import {
  Select,
  OutlinedInput,
  MenuItem,
  withStyles
} from "@material-ui/core";
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  YAxis,
  XAxis,
  CartesianGrid, 
  Tooltip
} from "recharts";     
import Widget from "./Widget";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import '../styles/Events.css';
import searching from '../images/searching.gif';


const getDateName = (value) => {
  const date =  new Date(value);
  return date.toLocaleString('en-GB');
}

const getMainChartData = (events) => {
  const resultArray = [];
  
  let firstDate = new Date();
  if(events.length > 1){

    resultArray.push({
      date: getDateName(firstDate.setDate(firstDate.getDate()-7)),
      ["event"+events[0].id]: events[0].posAlarmStatus,
      ["event"+events[1].id]: events[1].preAlarmStatus
    });   
    }
  if(events.length > 1){
  for (let i = 0; i < events.length; i++) {

      if(i === 0 ){
        // resultArray.push({
        //   date: getDateName(events[i].created),
        //   ["event"+events[i].id]: events[i].preAlarmStatus,
        //   ["event"+events[i+1].id]: events[i].preAlarmStatus
        // });
      }else if(i===events.length-1){
        // resultArray.push({
        //   date: getDateName(events[i].created),
        //   ["event"+events[i].id]: events[i].preAlarmStatus,
        //   ["event"+events[i-1].id]: events[i].preAlarmStatus
        // });
      }else{
        resultArray.push({
          date: getDateName(events[i].created),
          ["event"+events[i].id]: events[i].posAlarmStatus,
          ["event"+events[i-1].id]: events[i].posAlarmStatus,
          ["event"+events[i+1].id]: events[i].posAlarmStatus
        });
      }
    }
  }
  if(events.length > 1){
  resultArray.push({
      date: getDateName(new Date()),
      ["event"+events[events.length-1].id]: events[events.length-1].posAlarmStatus,
      ["event"+events[events.length-2].id]: events[events.length-1].posAlarmStatus
    });
  } 

  return resultArray;
};

const getLineForEvent = (e, index) => {
  let color = '#949494'
  
    const jsx = (
    <Line
                  key={"event"+e.id}
                  type="stepAfter"
                  layout="horizontal"
                  dataKey={"event"+e.id}
                  label={<CustomizedLabel color={getColor(e.preAlarmStatus)}/>}
                  stroke={color}
                  isAnimationActive = {true}
                  
                  strokeWidth={4}
                  dot={{ stroke: color, strokeWidth: 9 }}
                />           
  );
  return jsx;
}

class CustomizedLabel extends PureComponent {
  render() {
    const {
      x, y, stroke, value, color,
    } = this.props;

    return (<text x={x} y={y} dy={-4} fill={stroke} fontSize={"1.5rem"} textAnchor="middle">{value}</text>);
  }
}

const getColor = (alarmStatus) => {
  if(alarmStatus === 0){
    return '#00a65a';
  }else if(alarmStatus === 1){
    return '#f39c12';
  }else{
    return '#dd4b39';
  }
}

const CustomTooltip = ({ active, payload, label, events }) => {
  if (active && payload !== null) {
    return (
      <div className="custom-tooltip">
        <p className="desc">{events.find(e => "event"+e.id === payload[1].name) !== undefined ? events.find(e => "event"+e.id === payload[1].name).summary : "No description available."}</p>
        <Button
            style= {
                  {
                    color:'white',
                    backgroundColor: getColor(payload[0].payload[payload[0].name]),
                    fontSize: '1rem',
                    fontFamily: 'Open Sans'
                  }}
                >
                  {
                    payload[0].payload.date
                  }
        </Button>
      </div>
    );
  }
  return null;
};



const EventChart = ({ classes, theme, events , handleChange, selected, ...props }) => {
  if(events === undefined || events.length === 0)
    return (<div class="eventsNotFoundChart">
      <Typography variant="h4" color="textSecondary">
            No events found for the last: {selected}.
          </Typography>
          <br/>
          <Select
          value={selected}
          onChange={e => handleChange(e.target.value)}
          input={
            <OutlinedInput
              labelWidth={0}
              classes={{
                notchedOutline: classes.mainChartSelectRoot,
                input: classes.mainChartSelect
              }}
            />
          }
          autoWidth
        >
          <MenuItem value="1d">1 Day</MenuItem>
          <MenuItem value="7d">7 Days</MenuItem>
          <MenuItem value="15d">15 Days</MenuItem>
        </Select>
        <br/>
        <img src={searching} alt="searching"/></div>);
  else
    return (
      <Widget
            theme = {theme}
            bodyClass={classes.mainChartBody}
            header={
              <div className={classes.mainChartHeader}>
                <Typography variant="h4" color="textSecondary">
                  Events History Chart
                </Typography>
                <div className={classes.mainChartHeaderLabels}>
                  <div className={classes.mainChartHeaderLabel}>
                    
                    <p className="red">
                      • Critical - 2
                     </p>
                   
                  </div>
                  <div className={classes.mainChartHeaderLabel}>
                    
                    <p className="amber">
                      • Alert - 1
                     </p>
                   
                  </div>
                  <div className={classes.mainChartHeaderLabel}>
                    
                    <p className="green">
                      • Active - 0
                     </p>
                   
                  </div>
                </div>
                <Select
                  value={selected}
                  onChange={e => handleChange(e.target.value)}
                  input={
                    <OutlinedInput
                      labelWidth={0}
                      classes={{
                        notchedOutline: classes.mainChartSelectRoot,
                        input: classes.mainChartSelect
                      }}
                    />
                  }
                  autoWidth
                >
                  <MenuItem value="1d">1 Day</MenuItem>
                  <MenuItem value="7d">7 Days</MenuItem>
                  <MenuItem value="15d">15 Days</MenuItem>
                </Select>
              </div>
            }
          >
            <ResponsiveContainer width="100%" minWidth={500} height={350}>
              <ComposedChart
                margin={{ top: 0, right: -15, left: -15, bottom: 0 }}
                data={getMainChartData(events)}
              >
                <YAxis
                  ticks={[0, 1, 2, 3]}
                  tick={{ fill: theme.palette.text.hint + "80", fontSize: 14 }}
                  stroke={theme.palette.text.hint + "80"}
                  tickLine={false}
                />
                <XAxis
                  dataKey = "date"
                  //xAxisId = {i => i + 1}
                  //tickFormatter={i => i + 1}
                  tick={{ fill: theme.palette.text.hint + "80", fontSize: 14 }}
                  stroke={theme.palette.text.hint + "80"}
                  tickLine={false}
                />
                <CartesianGrid stroke="#f5f5f5" />
                <Tooltip content={<CustomTooltip events={events}/>} />
                
                {
                  events.map( (e, index) => {
                     const jsx = getLineForEvent(e, index);
                    return jsx;
                  })
                }

              </ComposedChart>
            </ResponsiveContainer>
          </Widget>
        );
      };


      const styles = theme => ({
        card: {
          minHeight: "100%",
          display: "flex",
          flexDirection: "column"
        },
        visitsNumberContainer: {
          display: "flex",
          alignItems: "center",
          flexGrow: 1,
          paddingBottom: theme.spacing.unit
        },
        progressSection: {
          marginBottom: theme.spacing.unit
        },
        progressTitle: {
          marginBottom: theme.spacing.unit * 2
        },
        progress: {
          marginBottom: theme.spacing.unit,
          backgroundColor: theme.palette.primary.main
        },
        pieChartLegendWrapper: {
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-end",
          marginRight: theme.spacing.unit
        },
        legendItemContainer: {
          display: "flex",
          alignItems: "center",
          marginBottom: theme.spacing.unit
        },
        fullHeightBody: {
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          justifyContent: "space-between"
        },
        tableWidget: {
          overflowX: "auto"
        },
        progressBar: {
          backgroundColor: "white"
        },
        performanceLegendWrapper: {
          display: "flex",
          flexGrow: 1,
          alignItems: "center",
          marginBottom: theme.spacing.unit
        },
        legendElement: {
          display: "flex",
          alignItems: "center",
          marginRight: theme.spacing.unit * 2
        },
        legendElementText: {
          marginLeft: theme.spacing.unit
        },
        serverOverviewElement: {
          display: "flex",
          alignItems: "center",
          maxWidth: "100%"
        },
        serverOverviewElementText: {
          minWidth: 145,
          paddingRight: theme.spacing.unit * 2
        },
        serverOverviewElementChartWrapper: {
          width: "100%"
        },
        mainChartBody: {
          overflowX: "auto"
        },
        mainChartHeader: {
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          [theme.breakpoints.only("xs")]: {
            flexWrap: "wrap"
          }
        },
        mainChartHeaderLabels: {
          display: "flex",
          alignItems: "center",
          [theme.breakpoints.only("xs")]: {
            order: 3,
            width: "100%",
            justifyContent: "center",
            marginTop: theme.spacing.unit * 3,
            marginBottom: theme.spacing.unit * 2
          }
        },
        mainChartHeaderLabel: {
          display: "flex",
          alignItems: "center",
          marginLeft: theme.spacing.unit * 3
        },
        mainChartSelectRoot: {
          borderColor: theme.palette.text.hint + "80 !important"
        },
        mainChartSelect: {
          padding: 10,
          paddingRight: 25
        },
        mainChartLegentElement: {
          fontSize: "18px !important",
          marginLeft: theme.spacing.unit
        }
      });
      
      export default withStyles(styles, { withTheme: true })(EventChart);
      


// WEBPACK FOOTER //
// ./src/components/EventsChart.js